export default __webpack_public_path__ + "static/media/ic_whatsapp.f169a322.svg";